var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27055 15.6561C10.534 12.9277 14.7107 11.129 16.8005 10.26C22.7672 7.77867 24.0071 7.34764 24.8152 7.3334C24.9929 7.33027 25.3903 7.37431 25.6478 7.58315C25.8651 7.7595 25.9249 7.99771 25.9535 8.1649C25.9822 8.33209 26.0178 8.71296 25.9895 9.01056C25.6661 12.4073 24.267 20.6503 23.5553 24.4547C23.2541 26.0644 22.661 26.6042 22.0869 26.657C20.8392 26.7718 19.8918 25.8326 18.6833 25.0406C16.7923 23.8012 15.724 23.0297 13.8884 21.8204C11.7671 20.4227 13.1423 19.6546 14.3512 18.3992C14.6676 18.0706 20.165 13.0712 20.2714 12.6177C20.2847 12.561 20.2971 12.3496 20.1714 12.2379C20.0458 12.1263 19.8604 12.1645 19.7266 12.1948C19.5369 12.2379 16.516 14.2342 10.6638 18.1838C9.80637 18.7725 9.02969 19.0593 8.33382 19.0443C7.56667 19.0277 6.09099 18.6106 4.99398 18.2541C3.64844 17.8168 2.57904 17.5856 2.67216 16.8429C2.72066 16.4561 3.25346 16.0605 4.27055 15.6561Z",
    fill: "#48BAF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram2);
export default __webpack_public_path__ + "static/media/telegram-2.10ad2017a78d608ce426d8457ec380c3.svg";
export { ForwardRef as ReactComponent };